import { configureStore } from "@reduxjs/toolkit";
import { positionSlice, PositionsState } from "./reducers/positionSlice";
import { config } from "./config";
import { symbolSlice } from "./reducers/symbolSlice";
import { lookupSlice } from "./reducers/lookupSlice";
import themeReducer from "./reducers/themeSlice";
import optionsSlice from "./reducers/optionsSlice";

export interface Store {
	alpaca: PositionsState;
}

export const store = configureStore({
    reducer: {
        alpaca: positionSlice.reducer,
        symbols: symbolSlice.reducer,
        lookups: lookupSlice.reducer,
        theme: themeReducer,
        options: optionsSlice.reducer
    },
    devTools: config.env === 'local'
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;